import Accordion from 'react-bootstrap/Accordion';
import faqs from "../assets/FAQ.json"
export default function Help() {
    return (
        <div className='help d-flex justify-content-center'>
            <div className='help-area'>
                <h2 className='fw-bold text-center mb-3 mb-lg-4' >Frequently Asked Questions</h2>
                <Accordion defaultActiveKey={'0'}>
                    {faqs.map((item, index) => (
                        <Accordion.Item eventKey={`${index}`} key={index}>
                            <Accordion.Header>{item.title}</Accordion.Header>
                            <Accordion.Body>
                                {item.des}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </div>
        </div>
    )
}
